import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { DynamicRenderContainerComponent } from './components/dynamic-render-container/dynamic-render-container.component'


@NgModule({
  declarations: [ DynamicRenderContainerComponent ],
  exports: [ DynamicRenderContainerComponent ],
  imports: [
    CommonModule
  ]
})
export class DynamicRenderModule {
}
